import React from 'react';
import PropTypes from 'prop-types';
import { IMask, IMaskInput } from 'react-imask';

export const TimeMask = React.forwardRef(
  ({ name, onChange, ...props }, ref) => (
    <IMaskInput
      {...props}
      mask="h:mm a"
      blocks={{
        h: {
          mask: IMask.MaskedNumber,
          min: 1,
          max: 12,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
        },
        a: {
          mask: IMask.MaskedEnum,
          enum: ['AM', 'PM'],
          prepare: (value) => `${value.toUpperCase()}M`,
        },
      }}
      inputRef={ref}
      onAccept={(value, _, event) => {
        // event is only truthy if a user actively typed otherwise undefined.
        if (event) {
          onChange(value);
        }
      }}
      overwrite
    />
  ),
);

TimeMask.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
